import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon, ClockIcon } from 'lucide-react';
interface CountdownTimerProps {
  targetDate: string;
}
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  targetDate
}) => {
  const calculateTimeLeft = (): TimeLeft => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft: TimeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor(difference / (1000 * 60 * 60) % 24),
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      };
    }
    return timeLeft;
  };
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft());
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);
    return () => clearTimeout(timer);
  });
  const formatDate = (dateString: string): string => {
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'America/New_York'
    };
    return new Intl.DateTimeFormat('es-ES', options).format(date);
  };
  const timeBlocks = [{
    label: 'Días',
    value: timeLeft.days
  }, {
    label: 'Horas',
    value: timeLeft.hours
  }, {
    label: 'Minutos',
    value: timeLeft.minutes
  }, {
    label: 'Segundos',
    value: timeLeft.seconds
  }];
  return <section className="py-6 px-4 relative" data-id="element-109">
      <div className="container mx-auto max-w-6xl" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-blue-900/20 via-purple-900/20 to-pink-900/20 backdrop-blur-sm p-6 md:p-8 rounded-2xl border border-gray-800 relative overflow-hidden" data-id="element-111">
          {/* Efecto de luz */}
          <div className="absolute -bottom-10 -right-10 w-64 h-64 bg-purple-500/20 blur-[100px] rounded-full" data-id="element-112"></div>
          <div className="text-center mb-6" data-id="element-113">
            <h2 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-114">
              La clase comienza en:
            </h2>
            <div className="flex items-center justify-center gap-2 text-gray-300" data-id="element-115">
              <CalendarIcon size={18} className="text-purple-400" data-id="element-116" />
              <span data-id="element-117">25 de Noviembre, 2025</span>
              <span className="mx-2" data-id="element-118">•</span>
              <ClockIcon size={18} className="text-purple-400" data-id="element-119" />
              <span data-id="element-120">7:00 PM (Hora de Miami)</span>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-121">
            {timeBlocks.map((block, index) => <motion.div key={block.label} initial={{
            scale: 0.9,
            opacity: 0
          }} whileInView={{
            scale: 1,
            opacity: 1
          }} transition={{
            duration: 0.3,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="bg-gray-900 p-4 rounded-lg border border-gray-800 text-center" data-id="element-122">
                <div className="text-3xl md:text-5xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400" data-id="element-123">
                  {block.value < 10 ? `0${block.value}` : block.value}
                </div>
                <div className="text-sm text-gray-400 mt-1" data-id="element-124">{block.label}</div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
};